/**
 * Slash-command skills for MCP chat (`/` menu).
 * Mode commands stay local; API-backed skills load from `GET /chat/skills`.
 */

export type McpSlashSkill = {
  id: string;
  /** Command typed after `/` (no leading slash). */
  command: string;
  title: string;
  description: string;
  category: string;
  /**
   * Text placed in the composer when selected.
   * Ignored when `action` is set.
   */
  prompt?: string;
  /**
   * Special action instead of filling a prompt (e.g. enter Help mode).
   */
  action?: 'enter-help';
  /** `api` = loaded from chat_skills table. */
  source?: 'mode' | 'api';
};

/** Mode-switch commands shown at the top of the `/` menu. */
export const MCP_SLASH_MODE_SKILLS: McpSlashSkill[] = [
  {
    id: 'mode-help',
    command: 'help',
    title: 'راهنما',
    description: 'پرسش از دانش‌نامه FAQ محصول',
    category: 'حالت',
    prompt: '',
    action: 'enter-help',
    source: 'mode'
  }
];
